import controller from './vd-autocomplete.controller'
import template from './vd-autocomplete.html'

export default {
  bindings: {
    placeholder: '@',
    icon: '@?',
    source: '<',
    debounceOptions: '<',
    disabled: '<',
    onSelect: '&?',
    lazyLoad: '<?',
    errorTemplate: '@?',
  },
  controller,
  require: {
    ngModelCtrl: '?^ngModel',
  },
  template,
}
